/* global axios */
import ApiClient from '../ApiClient';

class CaptainProactiveTriggers extends ApiClient {
  constructor() {
    super('captain_proactive_triggers', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data = {}) {
    return axios.post(this.url, { proactive_trigger: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { proactive_trigger: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  toggle(id) {
    return axios.post(`${this.url}/${id}/toggle`);
  }
}

export default new CaptainProactiveTriggers();
